import * as Sentry from "@sentry/nextjs";
import firebase from "firebase/app";
import { TFunction } from "next-i18next";
import { NextRouter } from "next/router";

import { RouteName } from "@/consts";
import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { SnackbarProps } from "@/features/common/hooks/snackbar/type";

type OnClickLocation =
  | "siteTopNavigation"
  | "mobileNavigation"
  | "desktopEmptyPlaceholder"
  | "bottomAppBar"
  | "mobileEmptyPlaceholder";
type CreatePostHelperArgs = {
  onClickLocation: OnClickLocation;
  createPost: any;
  router: NextRouter;
  openSnackbar: (snackbarProps: SnackbarProps) => void;
  t: TFunction;
};

export const createPostHelper = async (args: CreatePostHelperArgs) => {
  const { onClickLocation, createPost, router, openSnackbar, t } = args;

  firebase.analytics().logEvent(getLogEvent(onClickLocation));
  try {
    const resp = await createPost();
    router.push(`${RouteName.NewPost}/${resp.data.createPost.slug}`);
  } catch (e) {
    Sentry.captureException(e);
    openSnackbar({
      message: t("common:errors.fail"),
      severity: "error",
    });
  }
};

const getLogEvent = (onClickLocation: OnClickLocation) => {
  switch (onClickLocation) {
    case "siteTopNavigation":
      return AnalyticsEventEnum.PostCreate;
    case "mobileNavigation":
      return AnalyticsEventEnum.PostCreateMobile;
    case "desktopEmptyPlaceholder":
      return AnalyticsEventEnum.PostEmptyPlaceholderCreate;
    case "mobileEmptyPlaceholder":
      return AnalyticsEventEnum.PostEmptyPlaceholderCreateMobile;
    case "bottomAppBar":
      return AnalyticsEventEnum.PostCreateMobileBottomAppBar;
    default:
      return AnalyticsEventEnum.PostCreate;
  }
};
